import { QueryParams, useNativeDownload } from '@hooks/download/useNativeDownload';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveSite } from '@redux/authent/authent.selectors';
import { C2_URL } from '@services/c2/c2.api';
import { useCallback } from 'react';

interface SensorsRawParams extends QueryParams {
  from: string;
  to: string;
  sensorCodes: string[];
}

export function useDownloadSensorRaw() {
  const activeSite = useAppSelector(selectActiveSite);
  const site = activeSite?.code ?? '';
  const downloadUrl = `${C2_URL}/sensor/${site}/replay/raw`;

  const { startDownload: start, isLoading, isError } = useNativeDownload();

  const startDownloadSensorRaw: (params: SensorsRawParams) => Promise<void> = useCallback(
    (params) => start(downloadUrl, params, `sensor-raw-${params.from}-${params.to}.zip`),
    [downloadUrl, start],
  );

  return { startDownload: startDownloadSensorRaw, isLoading, isError };
}
